export default __webpack_public_path__ + "static/media/danskeheadline-webfont.903b2bbc.svg";